import { CRIcon } from '@/components/crRender';
import React, { useRef, useState } from 'react'

import { Message } from '..';
import { translate } from '@/utils/langUtils';
const UserWritingSection = ({ sendAPI, providerOrderId, setMessages }) => {

    const [newMessage, setNewMessage] = useState("");
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [sending, setSending] = useState(false);

    const handleSendMessage = () => {

        if (!newMessage.trim() || sending) return;

        setSending(true);
        const requestBody = {
            message: newMessage,
        };

        sendAPI(providerOrderId, requestBody).then(res => {

            const newMessageObject: Message = {
                id: Date.now(),
                message: newMessage,
                isMine: true,
                attachmentsPath: "",
                date: new Date().toISOString(),
            };
            setMessages((prev) => [...prev, newMessageObject]);
            setNewMessage("");
        }).finally(() => {
            setSending(false);
        });
    }

    const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNewMessage(e.target.value);
        const textarea = e.target;
        textarea.style.height = "auto";
        textarea.style.height = Math.min(textarea.scrollHeight, 120) + "px";
    };
    return (
        <div className="chat-input-container">
            <div className="chat-input-wrapper">
                <textarea
                    ref={textareaRef}
                    className="chat-textarea"
                    placeholder={translate("Type your message...") }
                    value={newMessage}
                    onChange={handleTextareaChange}
                    onKeyPress={handleKeyPress}
                    disabled={sending}
                    rows={1}
                />
                <button className="chat-send-btn" onClick={handleSendMessage} disabled={!newMessage.trim() || sending}>
                    <CRIcon isRender={!!sending} icon="mdi:loading" className="spinning" />
                    <CRIcon isRender={!sending} icon="mdi:send" className="chat-send-btn-icon" />
                </button>
            </div>
        </div>)
}

export default UserWritingSection